"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodService = void 0;
const Base_1 = require("../Base");
const apiRoutes_1 = require("../../utils/apiRoutes");
class PaymentMethodService extends Base_1.BaseService {
    /**
     * This method is responsible for getting only one Payment Method
     * that is passed through params. Probably you don't need it and
     * you should use fetchPaymentMethodsAccount instead.
     */
    getPaymentMethodAccount(accountId, paymentMethodId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodAccountApiUrl)(accountId, paymentMethodId),
            method: 'get',
            params,
        }).then(({ paymentMethod }) => paymentMethod);
    }
    /**
     * This method is responsible for getting only one Payment Method
     * that is passed through params. Probably you don't need it and
     * you should use fetchPaymentMethods instead.
     */
    getPaymentMethodOrder(orderId, paymentMethodId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodOrderApiUrl)(orderId, paymentMethodId),
            method: 'get',
            params,
        }).then(({ paymentMethod }) => paymentMethod);
    }
    fetchPaymentMethods(params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsApiUrl)(),
            method: 'get',
            params,
        }).then(({ paymentMethods }) => paymentMethods);
    }
    fetchPaymentMethodsAccount(accountId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsAccountApiUrl)(accountId),
            method: 'get',
            params,
        }).then(({ paymentMethods }) => paymentMethods);
    }
    fetchPaymentMethodsOrder(orderId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsOrderApiUrl)(orderId),
            method: 'get',
            params,
        }).then(({ paymentMethods }) => paymentMethods);
    }
    fetchExpressPaymentMethods(accountId, params) {
        return this.request({
            url: (0, apiRoutes_1.expressPaymentMethodsUrl)(accountId, params),
            method: 'get',
        });
    }
    fetchBuyNowPayLaterMethods(accountId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsBuyNowPayLaterApiUrl)(accountId),
            method: 'get',
            params,
        });
    }
}
exports.PaymentMethodService = PaymentMethodService;
//# sourceMappingURL=index.js.map